import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../api";
import { useLang } from "../i18n";
import { toast } from "sonner";

export default function AdminLogin() {
  const { t } = useLang();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("ra_admin_token")) {
      nav("/admin/dashboard", { replace: true });
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", form);
      localStorage.setItem("ra_admin_token", res.data.access_token);
      localStorage.setItem("ra_admin_email", res.data.email);
      nav("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F0F0F] px-6" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <Link to="/" className="font-serif text-3xl text-[#D4AF37]">Roland Azar</Link>
          <div className="text-[0.65rem] uppercase tracking-[0.25em] text-white/40 mt-2">L'Expert immobilier P.M.</div>
        </div>
        <div className="bg-[#141414] border border-white/5 p-10">
          <h1 className="font-serif text-3xl text-[#F5F5F0] mb-2">{t.admin.login_title}</h1>
          <span className="gold-line mb-8"></span>
          <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
            <input
              required type="email" placeholder="Email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="input-line"
              data-testid="admin-email"
            />
            <input
              required type="password" placeholder="Password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="input-line"
              data-testid="admin-password"
            />
            <button type="submit" disabled={loading} className="btn-gold w-full disabled:opacity-50" data-testid="admin-login-submit">
              {loading ? "..." : t.admin.login_cta}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
